import React from "react";
import ModuleCard, { ModuleItem } from "./ModuleCard";

/**
 * Grilla responsive de 3 columnas para los 6 módulos principales del sistema.
 */
const MODULES: ModuleItem[] = [
  {
    id: "personas",
    title: "Personas",
    href: "/busqueda/resultados",
    description: "Búsqueda y gestión unificada de registros de personas y familias.",
    icon: (
      <svg className="w-6 h-6" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
        <circle cx="9" cy="7" r="4" />
        <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
        <path d="M16 3.13a4 4 0 0 1 0 7.75" />
      </svg>
    ),
  },
  {
    id: "dif",
    title: "Desarrollo infantil en familia",
    href: "/programas/dif-list",
    description: "Programa de estimulación, nutrición y acompañamiento infantil.",
    icon: (
      <svg className="w-6 h-6" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
        <polyline points="9 22 9 12 15 12 15 22" />
      </svg>
    ),
  },
  {
    id: "oficios",
    title: "Oficios",
    href: "/programas/oficios/listado",
    description: "Talleres de capacitación laboral, seguimiento y entregas de herramientas.",
    icon: (
      <svg className="w-6 h-6" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <rect x="2" y="7" width="20" height="14" rx="2" ry="2" />
        <path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16" />
      </svg>
    ),
  },
  {
    id: "embarazadas",
    title: "Embarazadas",
    href: "/programas/resultados/embarazadas",
    description: "Control prenatal, talleres y entregas de ajuares de maternidad.",
    icon: (
      <svg className="w-6 h-6" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" />
      </svg>
    ),
  },
  {
    id: "salud",
    title: "Salud",
    href: "/salud/resultados",
    description: "Atenciones médicas, diagnósticos y controles de salud comunitaria.",
    icon: (
      <svg className="w-6 h-6" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <path d="M22 12h-4l-3 9L9 3l-3 9H2" />
      </svg>
    ),
  },
  {
    id: "informes",
    title: "Informes",
    href: "/informes",
    description: "Reportes consolidados, métricas operativas e indicadores generales.",
    icon: (
      <svg className="w-6 h-6" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
        <polyline points="14 2 14 8 20 8" />
        <line x1="16" y1="13" x2="8" y2="13" />
        <line x1="16" y1="17" x2="8" y2="17" />
        <polyline points="10 9 9 9 8 9" />
      </svg>
    ),
  },
];

export const ModuleGrid: React.FC = () => {
  return (
    <section aria-label="Módulos del sistema" className="space-y-3">
      <div className="flex items-center justify-between">
        <h2 className="text-xs font-bold uppercase tracking-wider text-gray-400">
          Módulos Principales
        </h2>
        <span className="text-xs text-gray-400">6 módulos disponibles</span>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
        {MODULES.map((mod) => (
          <ModuleCard key={mod.id} module={mod} />
        ))}
      </div>
    </section>
  );
};

export default ModuleGrid;
